import { useEffect, useRef, useState } from 'react';

// Kamera ilə barkod (KT-101): telefon və planşetdə brauzerin öz BarcodeDetector-u ilə (kənar kitabxana və xidmət yoxdur,
// görüntü cihazdan çıxmır). Dəstəkləməyən brauzerdə düymə göstərilmir.

interface Detector {
  detect: (src: HTMLVideoElement) => Promise<{ rawValue: string }[]>;
}
type DetectorCtor = new (opts: { formats: string[] }) => Detector;

export function cameraScanSupported(): boolean {
  return typeof window !== 'undefined' && 'BarcodeDetector' in window && Boolean(navigator.mediaDevices?.getUserMedia);
}

export function CameraScan({ onCode, onClose }: { onCode: (code: string) => void; onClose: () => void }) {
  const video = useRef<HTMLVideoElement>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let stream: MediaStream | null = null;
    let stopped = false;
    let timer = 0;
    const Ctor = (window as unknown as { BarcodeDetector: DetectorCtor }).BarcodeDetector;
    const detector = new Ctor({ formats: ['ean_13', 'ean_8', 'upc_a', 'upc_e', 'code_128', 'code_39', 'qr_code'] });
    navigator.mediaDevices
      .getUserMedia({ video: { facingMode: 'environment' }, audio: false })
      .then(async (s) => {
        // Pəncərə icazə gözlənərkən bağlanıbsa kamera açıq qalmasın
        if (stopped || !video.current) {
          s.getTracks().forEach((t) => t.stop());
          return;
        }
        stream = s;
        video.current.srcObject = s;
        await video.current.play();
        const tick = async () => {
          if (stopped || !video.current) return;
          try {
            const found = await detector.detect(video.current);
            if (found[0]?.rawValue) {
              stopped = true;
              onCode(found[0].rawValue);
              return;
            }
          } catch {
            /* kadr hazır deyil — növbəti kadr */
          }
          timer = window.setTimeout(() => void tick(), 250);
        };
        void tick();
      })
      .catch(() => setError('Kameraya icazə verilmədi və ya kamera yoxdur'));
    return () => {
      stopped = true;
      window.clearTimeout(timer);
      stream?.getTracks().forEach((t) => t.stop());
    };
  }, []);

  return (
    <div className="modal-overlay">
      <div className="modal-box card" role="dialog" aria-modal="true" aria-label="Kamera ilə barkod">
        <h2>Barkodu kameraya tutun</h2>
        {error ? (
          <p className="bad" role="alert">
            {error}
          </p>
        ) : (
          <video ref={video} className="camera-view" muted playsInline />
        )}
        <button type="button" className="btn-small" onClick={onClose}>
          Bağla
        </button>
      </div>
    </div>
  );
}
